import Alma from '../../../icons/Alma';
import React, { Fragment } from 'react';
import ReactHtmlParser from 'react-html-parser';

const Message = (props) => {
  const { message } = props
  return (
    <Fragment>
      { message.speaks === 'bot' && <Alma /> }
      <div className="copy-body message">{ ReactHtmlParser( message.text ) }</div>
    </Fragment>
  )
}

export default Message
